import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { getProfile } from '../../reducer/profileSlice';
import { getAmphurData, getAmphurDataMap, getProvinceData, getProvinceDataMap, getRegionData, getRegionDataMap, getTambonData, getTambonDataMap } from '../../reducer/areaDataSlice';
// import dotenv from 'react-dotenv';
import { setAreaSelected } from '../../reducer/areaSelectedSlice';

let amphurMapProvince = {};
let tambonMapAmphur = {};
function AreaSelectedSetting() {
    const userProfile = useSelector(getProfile);
    const regionData = useSelector(getRegionData);
    const provinceData = useSelector(getProvinceData);
    const amphurData = useSelector(getAmphurData);
    const tambonData = useSelector(getTambonData);
    const regionMap = useSelector(getRegionDataMap);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonMap = useSelector(getTambonDataMap);
    // console.log(regionData);
    const dispatch = useDispatch();

    const [areaLevelSelected, setAreaLevelSeleceted] = useState("");
    const [dpcSelected, setDPCSelected] = useState("");
    const [provinceSelected, setProvinceSelected] = useState("");
    const [amphurSelected, setAmphurSelected] = useState("");
    const [tambonSelected, setTambonSelected] = useState("");
    // https://covid-ddc2.bigstream.cloud/trb/secure/report/get_dpc_with_prov_code?prov_code=10

    useEffect(() => {
        if (userProfile) {
            const org_level = parseInt(userProfile.org_level);
            let areaSelected = "thailand";
            let bbox = [97.3758964376, 5.69138418215, 105.589038527, 20.4178496363]
            let prov_list = undefined;
            setAreaLevelSeleceted(org_level);
            if (org_level === 2) {
                setDPCSelected(userProfile.health_region_code);
                areaSelected = userProfile.health_region_code;
                bbox = regionMap[userProfile.health_region_code].bbox_4326.split(",")
                prov_list = regionMap[userProfile.health_region_code].prov_list;
            } else if (org_level >= 3) {
                setProvinceSelected(userProfile.province_code);
                areaSelected = userProfile.province_code;
                bbox = provinceMap[userProfile.province_code].bbox_4326.split(",")
                if (org_level >= 4) {
                    setAmphurSelected(userProfile.amphur_code);
                    areaSelected = userProfile.amphur_code;
                    bbox = amphurMap[userProfile.amphur_code].bbox_4326.split(",")
                    if (org_level === 5) {
                        setTambonSelected(userProfile.tambon_code);
                        areaSelected = userProfile.tambon_code;
                        bbox = tambonMap[userProfile.tambon_code].bbox_4326.split(",")
                    }
                }
            }
            for (let index = 0; index < bbox.length; index++) {
                bbox[index] = parseFloat(bbox[index]);
            }
            dispatch(setAreaSelected({
                level: org_level,
                value: areaSelected,
                bbox: bbox,
                prov_list: prov_list
            }))
        }
    }, [userProfile, regionMap, provinceMap, amphurMap, tambonMap, dispatch])

    useEffect(() => {
        let tmp = {};
        for (let index = 0; index < amphurData.length; index++) {
            const element = amphurData[index];
            const province_code = element.amp_code.substr(0, 2);
            if (tmp[province_code] === undefined) {
                tmp[province_code] = [element];
            } else {
                tmp[province_code].push(element);
            }
        }
        amphurMapProvince = tmp;
    }, [amphurData])

    useEffect(() => {
        let tmp = {};
        for (let index = 0; index < tambonData.length; index++) {
            const element = tambonData[index];
            const amphur_code = element.tambon_code.substr(0, 4);
            if (tmp[amphur_code] === undefined) {
                tmp[amphur_code] = [element];
            } else {
                tmp[amphur_code].push(element);
            }
        }
        tambonMapAmphur = tmp;
    }, [tambonData])

    useEffect(() => {
        if (areaLevelSelected === 3) {
            if (provinceSelected !== "") {
                let bbox = provinceMap[provinceSelected].bbox_4326.split(",");
                for (let index = 0; index < bbox.length; index++) {
                    bbox[index] = parseFloat(bbox[index]);
                }
                dispatch(setAreaSelected({
                    level: areaLevelSelected,
                    value: provinceSelected,
                    bbox: bbox
                }))
            }
        } else if (areaLevelSelected === 4) {
            if (amphurSelected !== "") {
                let bbox = amphurMap[amphurSelected].bbox_4326.split(",");
                for (let index = 0; index < bbox.length; index++) {
                    bbox[index] = parseFloat(bbox[index]);
                }
                dispatch(setAreaSelected({
                    level: areaLevelSelected,
                    value: amphurSelected,
                    bbox: bbox
                }))
            }
        }
    }, [areaLevelSelected]) 

    // const handleChange = (event, newValue) => {
    //     // setAreaLevelSeleceted(newValue);
    //     // dispatch(setAreaLevel(newValue));
    // };
    return (
        <>
        <Box sx={{
                textAlign: 'left'
            }}>
                <Typography 
                    variant="h6"
                    component="h6" 
                    sx={{
                        color: 'black',
                        fontSize: '1rem',
                        fontWeight: '400',
                        mt: 2,
                        mb: 2
                }}>
                    พื้นที่การแสดงผล
                </Typography>
                <div style={{
                    position: 'relative',
                }}>
                    <FormControl fullWidth size='small' sx={{
                        // marginTop: '10px'
                    }}>
                        <InputLabel id="area-level-select-label">ระดับการแสดงผล</InputLabel>
                        <Select
                            labelId="area-level-select-label"
                            id="demo-simple-select"
                            value={areaLevelSelected}
                            label="ระดับการแสดงผล"
                            onChange={(event) => {
                                setAreaLevelSeleceted(event.target.value);
                                setDPCSelected("");
                                // setProvinceSelected("");
                                // setAmphurSelected("");
                                // setTambonSelected("");
                                if (event.target.value < 3) {
                                    setProvinceSelected("");
                                    setAmphurSelected("");
                                    setTambonSelected("");
                                } else {
                                    if (event.target.value < 4) {
                                        setAmphurSelected("");
                                        setTambonSelected("");
                                    } else {
                                        setTambonSelected("");
                                    }
                                }
                                if (event.target.value === 1) {
                                    dispatch(setAreaSelected({
                                        level: 1,
                                        value: "thailand",
                                        bbox: [97.3758964376, 5.69138418215, 105.589038527, 20.4178496363]
                                    }))
                                }
                            }}
                        >
                            <MenuItem value={1}>ประเทศ</MenuItem>
                            <MenuItem value={2}>เขตสุขภาพ</MenuItem>
                            <MenuItem value={3}>จังหวัด</MenuItem>
                            <MenuItem value={4}>อำเภอ</MenuItem>
                            <MenuItem value={5}>ตำบล</MenuItem>
                        </Select>
                    </FormControl>
                    {
                        areaLevelSelected === 2 ?
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '20px'
                        }}>
                            <InputLabel id="region-select-label">เขตสุขภาพ</InputLabel>
                            <Select
                                labelId="region-select-label"
                                id="demo-simple-select"
                                value={dpcSelected}
                                label="เขตสุขภาพ"
                                onChange={(event) => {
                                    let bbox = regionMap[event.target.value].bbox_4326.split(",");
                                    for (let index = 0; index < bbox.length; index++) {
                                        bbox[index] = parseFloat(bbox[index]);
                                    }
                                    setDPCSelected(event.target.value);
                                    dispatch(setAreaSelected({
                                        level: areaLevelSelected,
                                        value: event.target.value,
                                        bbox: bbox,
                                        prov_list: regionMap[event.target.value].prov_list
                                    }))
                                }}
                            >
                                {
                                    regionData.map((data) => {
                                        return (
                                            <MenuItem key={data.health_region_code} name={data.bbox_4326} value={data.health_region_code}>{data.health_region_name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl> : <></>
                    }
                    {
                        areaLevelSelected >= 3 ?
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '20px'
                        }}>
                            <InputLabel id="province-select-label">จังหวัด</InputLabel>
                            <Select
                                labelId="province-select-label"
                                id="demo-simple-select"
                                value={provinceSelected}
                                label="จังหวัด"
                                onChange={(event) => {
                                    setAmphurSelected("");
                                    setTambonSelected("");
                                    setProvinceSelected(event.target.value);
                                    if (areaLevelSelected === 3) {
                                        let bbox = provinceMap[event.target.value].bbox_4326.split(",");
                                        for (let index = 0; index < bbox.length; index++) {
                                            bbox[index] = parseFloat(bbox[index]);
                                        }
                                        dispatch(setAreaSelected({
                                            level: areaLevelSelected,
                                            value: event.target.value,
                                            bbox: bbox
                                        }))
                                    }
                                    // setCompare(event.target.value)
                                }}
                            >
                                {
                                    provinceData.map((data) => {
                                        return (
                                            <MenuItem key={data.prov_code} value={data.prov_code}>{data.prov_namt}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl> : <></>
                    }
                    {
                        areaLevelSelected >= 4 ?
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '20px'
                        }}>
                            <InputLabel id="amphur-select-label">อำเภอ</InputLabel>
                            <Select
                                labelId="amphur-select-label"
                                id="demo-simple-select"
                                value={amphurSelected}
                                label="อำเภอ"
                                onChange={(event) => {
                                    setTambonSelected("");
                                    setAmphurSelected(event.target.value);
                                    if (areaLevelSelected === 4) {
                                        let bbox = amphurMap[event.target.value].bbox_4326.split(",");
                                        for (let index = 0; index < bbox.length; index++) {
                                            bbox[index] = parseFloat(bbox[index]);
                                        }
                                        dispatch(setAreaSelected({
                                            level: areaLevelSelected,
                                            value: event.target.value,
                                            bbox: bbox
                                        }))
                                    }
                                    // setCompare(event.target.value)
                                }}
                            >

                                {
                                    provinceSelected.length === 2 ?
                                        amphurMapProvince[provinceSelected].map((data) => {
                                            return (
                                                <MenuItem key={data.amp_code} value={data.amp_code}>{data.amp_namt}</MenuItem>
                                            )
                                        })
                                    : <MenuItem value={""}></MenuItem>
                                }
                            </Select>
                        </FormControl> : <></>
                    }
                    {
                        areaLevelSelected === 5 ?
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '20px'
                        }}>
                            <InputLabel id="tambon-select-label">ตำบล</InputLabel>
                            <Select
                                labelId="tambon-select-label"
                                id="demo-simple-select"
                                value={tambonSelected}
                                label="ตำบล"
                                onChange={(event) => {
                                    setTambonSelected(event.target.value);
                                    if (areaLevelSelected === 5) {
                                        let bbox = tambonMap[event.target.value].bbox_4326.split(",");
                                        for (let index = 0; index < bbox.length; index++) {
                                            bbox[index] = parseFloat(bbox[index]);
                                        }
                                        dispatch(setAreaSelected({
                                            level: areaLevelSelected,
                                            value: event.target.value,
                                            bbox: bbox
                                        }))
                                    }
                                    // setCompare(event.target.value)
                                }}
                            >

                                {
                                    amphurSelected.length === 4 ?
                                        tambonMapAmphur[amphurSelected].map((data) => {
                                            return (
                                                <MenuItem key={data.tambon_code} value={data.tambon_code}>{data.tambon_namt}</MenuItem>
                                            )
                                        })
                                    : <MenuItem value={""}></MenuItem>
                                }
                            </Select>
                        </FormControl> : <></>
                    }
                </div>
            </Box>
        </>
    )
}

export default AreaSelectedSetting;